// @ts-check
import React from "react"
export const BIG_CALENDAR_VIEWS = {
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
}

/** @type {import('react-big-calendar').Messages<Event>} */
export const DEFAULT_BIG_CALENDAR_MESSAGES = {
  next: <i className="pi pi-chevron-right" />,
  previous: <i className="pi pi-chevron-left" />,
  today: "Hoy",
  month: "Mes",
  week: "Semana",
  day: "Día",
  agenda: "Agenda",
  date: "Fecha",
  time: "Hora",
  event: "Evento",
  noEventsInRange: "No hay eventos en este rango.",
}

export const DEFAULT_BIG_VALENDAR_VIEWS = {
  week: true,
  month: true,
  year: true,
}
